import { Pipe, PipeTransform } from '@angular/core';


export const formatPid = (pid: string | null): string | null => {
    if (pid === null) {
        return pid;
    }

    try {
        const pidNumber = pid.match(/\d/g)!.join('');

        if (pidNumber.length !== 9) {
            throw new Error('PID has not 9 numbers: ' + pid);
        }

        return pidNumber.match(/.{3}/g)!.join('-');
    } catch (e) {
        console.error(e);
        return pid;
    }
};


@Pipe({
    name: 'pidFormat',
})
export class PidFormatPipe implements PipeTransform {

    transform(pid: string | null): string | null {
        return formatPid(pid);
    }
}
